var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRocket = function SvgIconRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.126.13-4.451.89c-.678.135-1.3.468-1.788.956L2.713 10.15 9.85 17.29l8.174-8.174a3.503 3.503 0 0 0 .957-1.788l.89-4.451A2.333 2.333 0 0 0 17.126.13Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.733 17.738 2.264 13.27a1.167 1.167 0 0 1 .457-1.933l.885-.294 5.353 5.353-.296.887a1.168 1.168 0 0 1-1.932.456l.002-.001Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.796 4.714.861 6.649a1.167 1.167 0 0 0 0 1.65l1.852 1.851L8.29 4.574l-4.618-.202a1.16 1.16 0 0 0-.875.342h-.001ZM15.288 17.206l-1.935 1.935a1.167 1.167 0 0 1-1.65 0l-1.851-1.852 5.576-5.577.201 4.617a1.16 1.16 0 0 1-.34.875v.002Z",
    fill: "#3987F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.571 9.91a2.48 2.48 0 1 0 0-4.959 2.48 2.48 0 0 0 0 4.959Z",
    fill: "#EBF5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.659 16.342a1.893 1.893 0 0 0-2.678 0c-.74.74-.875 2.166-.897 2.977a.581.581 0 0 0 .597.596c.81-.022 2.25-.169 2.976-.897.74-.739.74-1.938 0-2.677l.002.001Z",
    fill: "#F0464F"
  })));
};
export default SvgIconRocket;